import React from 'react';

import styles from './styles/compariosn-card.module.css';

export default function ComparisonCard({ title, Image }) {
  return (
    <div className={styles.wrapper}>
       <p>{title}</p>
       <div className={styles.boxImage}>
        <Image />
       </div>
    </div>
  );
}
